import { MessageCircle } from "lucide-react";
import { waLink, DEFAULT_WA_MESSAGE, isOpenNow } from "@/data/content";

export const FloatingWhatsApp = () => (
  <a
    href={waLink(DEFAULT_WA_MESSAGE)}
    target="_blank"
    rel="noopener noreferrer"
    data-testid="floating-whatsapp-btn"
    className="group fixed bottom-5 right-5 z-50 flex items-center gap-3 rounded-full bg-whatsapp py-3.5 pl-4 pr-5 text-white shadow-lift transition-all hover:-translate-y-1 hover:bg-whatsapp-dark"
    aria-label="WhatsApp ile yaz"
  >
    <span className="relative flex h-6 w-6 items-center justify-center">
      <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-white/40" />
      <MessageCircle className="relative h-5 w-5" />
    </span>
    <span className="hidden text-sm font-bold sm:block">
      {isOpenNow() ? "Atölye açık, yazın" : "WhatsApp'tan yazın"}
    </span>
  </a>
);

export default FloatingWhatsApp;
